export function getTicketSortIcon(ticketType: string): string {
  switch (ticketType) {
    case 'Festpreis':
      return 'sell';
    case 'Relation':
      return 'route';
    case 'Abonnement':
      return 'laps';
    default:
      return '';
  }
}
